'use strict';

const angular = require('angular');

module.exports = angular
  .module('spinnaker.gce.serverGroup.details.scalingPolicy.addButton', [
    require('angular-ui-bootstrap'),
    require('./modal/upsertAutoscalingPolicy.modal.controller.js').name,
  ])
  .component('gceAddAutoscalingPolicyButton', {
    bindings: {
      serverGroup: '=',
      application: '=',
    },
    template: '<a href ng-click="$ctrl.addAutoscalingPolicy()">Create new scaling policy</a>',
    controller: function($uibModal) {

      this.addAutoscalingPolicy = () => {
        $uibModal.open({
          templateUrl: require('./modal/upsertAutoscalingPolicy.modal.html'),
          controller: 'gceUpsertAutoscalingPolicyModalCtrl',
          controllerAs: 'ctrl',
          size: 'lg',
          resolve: {
            policy: () => undefined,
            serverGroup: () => this.serverGroup,
            application: () => this.application,
          }
        });
      };
    }
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/google/src/serverGroup/details/autoscalingPolicy/addAutoscalingPolicyButton.component.js